import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkUser } from '../reducers/User/actions';
import Dashboard from './Dashboard';
import Pages from './Pages';

const Views =  () => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();

  const properCheckUser = useCallback(() => {
    dispatch(checkUser());
  }, [dispatch]);

  useEffect(() => {
    properCheckUser();
  }, [properCheckUser]);

  if (!user.requested) {
    return null;
  }

  const isLogged = user.data?.id;

  return isLogged ? <Dashboard /> : <Pages />;
};

export default Views;
